import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Check } from 'lucide-react';
import { useTilt } from '../../hooks/use-tilt';

const PricingCard = ({ plan, scrollToContact }) => {
  const tiltRef = useTilt({ max: 8, scale: 1.04, speed: 600 });
  
  return (
    <div ref={tiltRef} className="group">
      <Card 
        className={`bg-gradient-to-br from-gray-900/70 via-gray-900/60 to-gray-900/50 border border-white/15 relative transition-all duration-300 h-full shadow-3d-hover premium-hover-lift ${
          plan.popular ? 'border-[#2F6BFF] shadow-xl shadow-[#2F6BFF]/20 scale-105' : 'hover:border-[#2F6BFF]/50'
        }`}
        style={{ 
          transformStyle: 'preserve-3d',
          boxShadow: plan.popular 
            ? '0 12px 32px rgba(47, 107, 255, 0.2), 0 24px 64px rgba(77, 163, 255, 0.15), inset 0 0 60px rgba(47, 107, 255, 0.05)'
            : '0 8px 24px rgba(0,0,0,0.4), 0 16px 48px rgba(0,0,0,0.2), inset 0 0 40px rgba(34,211,238,0.02)'
        }}
      >
        {plan.popular && (
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
            <Badge className="inline-flex items-center justify-center h-8 px-4 py-1.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] text-white text-sm font-medium leading-5 rounded-full shadow-lg hover:scale-105 transition-all duration-300">
              Most Popular
            </Badge>
          </div>
        )}
        <div style={{ transformStyle: 'preserve-3d', transform: 'translateZ(30px)' }}>
          <CardHeader>
            <CardTitle className="text-2xl text-[#F5F7FF] mb-4 group-hover:text-[#2F6BFF] transition-colors duration-300">
              {plan.title}
            </CardTitle>
            <div className="mt-2">
              <div className="flex items-baseline justify-center">
                <span className="text-5xl font-bold text-[#2F6BFF]" style={{ textShadow: '0 0 30px rgba(47, 107, 255, 0.3)' }}>
                  {plan.price}
                </span>
                <span className="text-[#9AA3B2] ml-2 text-base">setup</span>
              </div>
              <div className="text-[#9AA3B2] text-sm mt-2 text-center">
                + £25/month Website Care Plan
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <ul className="space-y-4 mb-8">
              {plan.features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3 group/item">
                  <Check className="h-5 w-5 text-[#2F6BFF] mt-0.5 flex-shrink-0 group-hover/item:scale-110 transition-transform duration-300" />
                  <span className="text-[#F5F7FF] text-sm leading-relaxed group-hover/item:text-gray-200 transition-colors duration-300">
                    {feature}
                  </span>
                </li>
              ))}
            </ul>
            <Button 
              onClick={scrollToContact}
              className={`w-full py-6 font-semibold transition-all duration-300 hover:scale-105 ${
                plan.popular 
                  ? 'bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] hover:from-[#4DA3FF] hover:to-[#2F6BFF] text-white shadow-lg shadow-[#2F6BFF]/30 hover:shadow-xl hover:shadow-[#4DA3FF]/40' 
                  : 'bg-[#2F6BFF]/10 hover:bg-[#2F6BFF]/20 text-[#2F6BFF] border border-[#2F6BFF]/30 hover:border-[#2F6BFF]/50'
              }`}
              style={{ transform: 'translateZ(10px)' }}
            >
              Get Started
            </Button>
          </CardContent>
        </div>
      </Card>
    </div>
  );
};

export default PricingCard;
